export const STREAM_NAME_MAX_LENGTH = 100;
export const STREAM_DESCRIPTION_MAX_LENGTH = 500;
export const STREAM_TAG_MAX_LENGTH = 25;
export const STREAM_TAGS_NOTICE = `Add up to 5 tags (Max ${STREAM_TAG_MAX_LENGTH} characters, no spaces or symbols).`;
export const STREAM_DISCLAIMER =
  "MILLIONS.co served as the streaming platform and completed all required testing. The event's live feed and technical production were managed independently by a third-party provider.";
